import { AbstractControl, ValidationErrors } from '@angular/forms';

export class FormValidators {
  static regexShouldBeValid(control: AbstractControl): ValidationErrors | null {
    try {
      const reg = new RegExp(control.value);
    } catch {
      return {
        regexIsNotValid: 'Pattern is not a valid regex',
      };
    }
    return null;
  }

  static noDuplicateValues(control: AbstractControl, values: string[]): ValidationErrors | null {
    if (control.value && values.includes(control.value)) {
      return {duplicateValue: true};
    }
    return null;
  }

  static maxLengthWithPrefix(control: AbstractControl, maxLength: number, prefix: string): ValidationErrors | null {
    if (prefix?.length + control.value?.length > maxLength) {
      return {
        maxLengthWithPrefix: {
          requiredLength: maxLength,
          prefixLength: prefix.length ?? 0
        }
      }
    } else {
      return null
    }
  }
}
